module.exports = __webpack_public_path__ + "media/tags/smartsearch/x-8e15b56cfecd0afb748ff56e69f48610.png";